import { T_SHIRT_SIZES } from './T_SHIRT_SIZES';
export var AVATAR_BADGE_BADGE_SIZES = Object.freeze({
  md: T_SHIRT_SIZES.md,
  lg: T_SHIRT_SIZES.lg,
  xl: T_SHIRT_SIZES.xl,
  xxl: T_SHIRT_SIZES.xxl
});